export const CommodityGroupForm = {
  model: 'CommodityGroup',
  format: [
    {
      widths: 'equal',
      fields: {
        name: {
          required: true,
          type: 'text',
          url: '/main/commodity-groups/',
          label: 'Create Commodity Group',
          title_fields: ['name'],
        },
      },
    },
  ],
}
